import { Controller } from "@hotwired/stimulus"
import Splide from '@splidejs/splide'
import PhotoSwipeLightbox from 'photoswipe/lightbox'

export default class extends Controller {
  static targets = ["imageSlider", "thumbnailSlider"]

  connect() {
    var main = new Splide( this.imageSliderTarget, {
      heightRatio: 1,
      gap             : 10,
      pagination : false,
      arrows     : false,
      waitForTransition: false
    })

    var thumbnails = new Splide( this.thumbnailSliderTarget, {
      arrows     : false,
      fixedWidth      : 104,
      fixedHeight     : 104,
      isNavigation    : true,
      gap             : 10,
      pagination      : false,
      classes: {
        prev  : 'splide__arrow--prev bg-white bg-opacity-50',
        next  : 'splide__arrow--next bg-white bg-opacity-50',
      },
      dragMinThreshold: {
        mouse: 4,
        touch: 10
      }
    })

    main.sync(thumbnails)
    main.mount()
    thumbnails.mount()

    const lightbox = new PhotoSwipeLightbox({
      gallery: '#gallery',
      children: 'a',
      hideAnimationDuration: 0,
      pswpModule: () => import('photoswipe')
    })

    lightbox.init()
  }
}
